import React, { useState, useRef } from "react";
import "./imagePopup.css";
import {
  FaFacebook,
  FaPinterest,
  FaDownload,
  FaSearchPlus,
  FaSearchMinus,
} from "react-icons/fa";
import { FaXTwitter, FaXmark, FaExpand } from "react-icons/fa6";

const ImagePopup = ({ image, onClose }) => {
  const [isMobile] = useState(window.innerWidth <= 768);
  const [zoom, setZoom] = useState(isMobile ? 1 : 0.5);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const isDragging = useRef(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const containerRef = useRef(null);

  const handleOverlayClick = (e) => {
    if (e.target === containerRef.current) {
      onClose();
    }
  };

  const zoomIn = () => setZoom((z) => Math.min(z + 0.2, 4));
  const zoomOut = () => {
    setZoom((z) => {
      const next = Math.max(z - 0.2, 0.5);
      if (next <= 1) setPosition({ x: 0, y: 0 });
      return next;
    });
  };

  const handleMouseDown = (e) => {
    if (zoom <= 0.5) return;
    isDragging.current = true;
    dragStart.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    setPosition({
      x: e.clientX - dragStart.current.x,
      y: e.clientY - dragStart.current.y,
    });
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  // touch support
  const handleTouchStart = (e) => {
    if (zoom <= 0.5) return;
    isDragging.current = true;
    const touch = e.touches[0];
    dragStart.current = {
      x: touch.clientX - position.x,
      y: touch.clientY - position.y,
    };
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    const touch = e.touches[0];
    setPosition({
      x: touch.clientX - dragStart.current.x,
      y: touch.clientY - dragStart.current.y,
    });
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = image;
    link.download = "image";
    link.click();
  };

  const share = (platform) => {
    const url = encodeURIComponent(window.location.href);
    const img = encodeURIComponent(image);
    const links = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      x: `https://twitter.com/intent/tweet?url=${url}`,
      pinterest: `https://pinterest.com/pin/create/button/?url=${url}&media=${img}`,
    };
    window.open(links[platform], "_blank");
  };

  const openFullscreen = () => {
    const elem = document.getElementById("popup-image");
    if (elem.requestFullscreen) elem.requestFullscreen();
  };

  return (
    <div
      ref={containerRef}
      onClick={handleOverlayClick}
      className="popup-overlay"
    >
      <div className="img-popup-container">
        <div className="popup-top-bar">
          <button onClick={zoomOut}>
            <FaSearchMinus />
          </button>
          <button onClick={zoomIn}>
            <FaSearchPlus />
          </button>
          <button onClick={openFullscreen}>
            <FaExpand />
          </button>
          <button onClick={onClose}>
            <FaXmark />
          </button>
        </div>

        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="image-wrapper"
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleMouseUp}
          style={{ cursor: zoom > 0.5 ? "grab" : "default" }}
        >
          <img
            id="popup-image"
            src={image}
            alt=""
            draggable={false}
            style={{
              width: `${zoom * 100}%`,
              height: "auto",
              transform: `translate(${position.x}px, ${position.y}px)`,
              transition: isDragging.current ? "none" : "transform 0.1s ease",
              userSelect: "none",
            }}
          />
        </div>

        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="share-buttons"
        >
          <button onClick={() => share("facebook")}>
            <FaFacebook /> Facebook
          </button>
          <button onClick={() => share("x")}>
            <FaXTwitter /> X
          </button>
          <button onClick={() => share("pinterest")}>
            <FaPinterest /> Pinterest
          </button>
          <button onClick={handleDownload}>
            <FaDownload /> Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImagePopup;
